export const parseOrganTitle = (organ: string) => {
  const organName = organ.split('_').join(' ');

  return organName.charAt(0).toUpperCase() + organName.slice(1);
};
